<template>
  <v-list dense nav>
    <v-list-item v-for="item in items" :key="item.title">
      <v-list-item-icon>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed v-bind="attrs" v-on="on">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-btn>
        </template>
        <v-card>
          <v-card-title color="blue lighten-4">
            <span color="blue lighten-4" class="text-h5">
              {{ $t("global.profile.change.password") }}
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    type="password"
                    :label="$t('global.profile.change.password.new')"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="passwordConfirm"
                    type="password"
                    :label="$t('global.profile.change.password.confirm')"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="changePassword()">
              {{ $t("global.confirm") }}
            </v-btn>
            <v-btn color="red darken-1" text @click="close()">
              {{ $t("global.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item>
  </v-list>
</template>

<script>
import localhttp from "@/js/https-commons";
import Vue from "vue";

const CONTEXT = "/access";

export default {
  data: () => ({
    dialog: false,
    password: null,
    passwordConfirm: null,
    strongPassword: new RegExp(
      "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=(.*[!@#$%^&*()-__+.]))(?=.{8,})"
    ),
    items: [{ title: "Cambiar Contraseña", icon: "fa-unlock-alt" }],
    usersDTO: {
      code: "",
      password: ""
    }
  }),
  methods: {
    changePassword() {
      let pattern = this.strongPassword;

      if (this.password === this.passwordConfirm) {
        if (pattern.test(this.password)) {
          this.usersDTO.code = Vue.$keycloak.tokenParsed.preferred_username;
          this.usersDTO.password = this.password;

          localhttp
            .put(CONTEXT + "/changePassword", this.usersDTO)
            .then(response => {
              console.log(response.data);
              this.$showMessage(this.$t("global.password.changed"));
              this.close();
              this.dialog = false;
            })
            .catch(e => {
              console.log(e);
              this.$showErrorMessage(
                this.$t("global.password.validation.error")
              );
              this.$showErrorCode(e.response.status);
            });
        } else {
          this.$showErrorMessage(this.$t("global.password.validation.error"));
        }
      } else {
        this.$showErrorMessage(this.$t("global.password.match.error"));
      }
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
